export default {
  FINANCE: 'finance',
  CASH: 'cash',
  LEASE: 'lease',
};
